import type {
  CreateProjectInput,
  Project,
  UpdateProjectInput,
} from '@bcl/shared';
import { api } from '@/lib/api';

export async function createProject(input: CreateProjectInput): Promise<Project> {
  const { data } = await api.post<Project>('/projects', input);
  return data;
}

export async function listProjects(): Promise<Project[]> {
  const { data } = await api.get<Project[]>('/projects');
  return data;
}

export async function getProject(id: string): Promise<Project> {
  const { data } = await api.get<Project>(`/projects/${id}`);
  return data;
}

export async function updateProject(
  id: string,
  patch: UpdateProjectInput,
): Promise<Project> {
  const { data } = await api.patch<Project>(`/projects/${id}`, patch);
  return data;
}

export async function submitProject(id: string): Promise<Project> {
  const { data } = await api.post<Project>(`/projects/${id}/submit`);
  return data;
}

export type TimelineEvent = {
  id: string;
  status: string;
  message: string | null;
  createdAt: string;
};

export async function getTimeline(id: string): Promise<TimelineEvent[]> {
  const { data } = await api.get<TimelineEvent[]>(`/projects/${id}/timeline`);
  return data;
}
